import React from "react";

const AtIconDown = ({ width = "116", height = "73", className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 116 73"
      className={className}
    >
      <path
        fill="#F05223"
        stroke="#fff"
        strokeWidth="2.083"
        d="M51.34 68.569a9.397 9.397 0 0 0 3.056 2.17A8.94 8.94 0 0 0 58 71.5a8.94 8.94 0 0 0 3.604-.762 9.397 9.397 0 0 0 3.055-2.17l47.083-49.995a10.067 10.067 0 0 0 2.041-3.245c.473-1.213.717-2.514.717-3.827 0-1.313-.244-2.614-.717-3.827a10.066 10.066 0 0 0-2.041-3.245 9.405 9.405 0 0 0-3.056-2.168 8.94 8.94 0 0 0-3.604-.761 8.944 8.944 0 0 0-3.604.761 9.397 9.397 0 0 0-3.055 2.168L58 47.354 17.577 4.429a9.402 9.402 0 0 0-3.055-2.168 8.943 8.943 0 0 0-3.604-.761 8.944 8.944 0 0 0-3.604.761A9.402 9.402 0 0 0 4.258 4.43a10.063 10.063 0 0 0-2.041 3.245A10.54 10.54 0 0 0 1.5 11.5c0 1.313.244 2.614.717 3.827a10.064 10.064 0 0 0 2.041 3.245l47.083 49.996Z"
      />
    </svg>
  );
};

export default AtIconDown;
